<div>
    <ng-container [ngSwitch]="question.typeConfig.type">
        <div class="text" *ngSwitchCase="QuestionType.Text">
            <p>
                {{ (managerAnswer ? 'managerEvaluation.ManagerAnswer' : 'managerEvaluation.employeeAnswer') | translate }}
            </p>
            <p class="answer" style="white-space: pre-wrap">{{ answer | toFixed: 2 }}</p>
        </div>

        <ng-container *ngSwitchCase="QuestionType.Slider">
            <ion-grid class="slider">
                <ion-row>
                    <ion-col size="2">
                        <p>{{ 'managerEvaluation.employeeAnswer' | translate }}</p>
                    </ion-col>
                    <ion-col *ngFor="let opValue of question.typeConfig.possibleValues; let vIndex = index"
                             [size]="10 / question.typeConfig.possibleValues.length">
                        <div class="circle"
                             *ngIf="evaluation && opValue === answer"
                             [style.borderColor]="'darkgray'"
                             [style.backgroundColor]="'darkgray'"
                        ></div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ng-container>
        <ng-container *ngSwitchCase="QuestionType.GroupedSlider">
            <ion-grid class="slider">
                <ion-row>
                    <ion-col size="2">
                        <p>{{ 'managerEvaluation.employeeAnswer' | translate }}</p>
                    </ion-col>
                    <ion-col *ngFor="let opValue of question.typeConfig.possibleValues; let vIndex = index"
                             [size]="10 / question.typeConfig.possibleValues.length">
                        <div class="circle"
                             *ngIf="evaluation && opValue === answer"
                             [style.borderColor]="'darkgray'"
                             [style.backgroundColor]="'darkgray'"
                        ></div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ng-container>
    </ng-container>
</div>